import _ from 'lodash'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { listChecklistProjects, listChecklists } from '../actions/checklist'

import ChecklistList from '../components/ChecklistList'

class ChecklistPage extends Component {
  componentDidMount () {
    const { listChecklists, listChecklistProjects } = this.props
    listChecklists()
    listChecklistProjects()
  }

  render () {
    return (<ChecklistList {...this.props}/>)
  }
}

const mapStateToProps = (state, ownProps) => ({
  query: _.get(state, 'checklist.query'),
  order: _.get(state, 'checklist.query.order'),
  list: _.get(state, 'checklist.list'),
  projects: _.get(state, 'checklist.projects.rows', []),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  listChecklists (query) {
    dispatch(listChecklists(query))
  },
  listChecklistProjects () {
    dispatch(listChecklistProjects())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistPage)



// WEBPACK FOOTER //
// ./src/containers/ChecklistPage.js